export const REGISTER_COMPANY = "REGISTER_COMPANY"
export const REGISTER_COMPANY_SUCCESS = "REGISTER_COMPANY_SUCCESS"
export const REGISTER_COMPANY_ERROR = "REGISTER_COMPANY_ERROR"

export const REGISTER_PERSONALUSER = "REGISTER_PERSONALUSER"
export const REGISTER_PERSONALUSER_SUCCESS = "REGISTER_PERSONALUSER_SUCCESS"
export const REGISTER_PERSONALUSER_ERROR = "REGISTER_PERSONALUSER_ERROR"

export const ACTIVATE_ACCOUNT = "ACTIVATE_ACCOUNT"
export const ACTIVATE_ACCOUNT_SUCCESS = "ACTIVATE_ACCOUNT_SUCCESS"
export const ACTIVATE_ACCOUNT_ERROR = "ACTIVATE_ACCOUNT_ERROR"